import { render, staticRenderFns } from "./historyManuscripts.vue?vue&type=template&id=316557fe&scoped=true&"
import script from "./historyManuscripts.vue?vue&type=script&lang=js&"
export * from "./historyManuscripts.vue?vue&type=script&lang=js&"
import style0 from "./historyManuscripts.vue?vue&type=style&index=0&id=316557fe&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316557fe",
  null
  
)

export default component.exports